import { useEffect } from 'react';
import { useAuth } from '../../auth/AuthContext.js';
import { useBrandContext, type BrandInfo } from './BrandContext.js';

/**
 * Synchroniseert de branding van de actieve entity (na login / switch-entity)
 * naar de BrandContext. Rendert niets.
 *
 * Hierdoor ziet een Heytens-user zijn huisstijl ook op app.c-bridge.app,
 * en volgt de UI de winkel-switcher (superadmin).
 */
export function EntityBrandSync() {
  const { token, activeEntity } = useAuth();
  const { setEntityBrand } = useBrandContext();
  const activeEntityId = activeEntity?.id ?? null;

  useEffect(() => {
    if (!token || !activeEntityId) {
      setEntityBrand(null);
      return;
    }
    let cancelled = false;
    fetch('/api/settings/branding', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((b) => {
        if (cancelled || !b) return;
        const info: BrandInfo = {
          bedrijfsNaam: b.bedrijfsNaam ?? null,
          logoUrl: b.logoUrl ?? null,
          kleurPrimair: b.kleurPrimair ?? null,
          kleurSecundair: b.kleurSecundair ?? null,
          entityId: activeEntityId,
          sectorType: b.sectorType ?? null,
        };
        setEntityBrand(info);
      })
      .catch(() => {
        /* branding is cosmetisch — nooit de app blokkeren */
      });
    return () => {
      cancelled = true;
    };
  }, [token, activeEntityId, setEntityBrand]);

  return null;
}
